export enum StateSlicesEnum {
    CHECKOUT = "checkout",
    PARENTS = "parents"
}
